export default __webpack_public_path__ + "static/media/WhatsApp Image1.088dcdc9.jpeg";